(function () {
  'use strict';

  var REQUEST_TIMEOUT_MS = 15000;

  function text(value) {
    return typeof value === 'string' ? value : '';
  }

  function trimmedField(form, name) {
    var field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[data-submit-button]');
    var spinner = form.querySelector('[data-loading-spinner]');
    var label = form.querySelector('[data-button-label]');
    if (button) button.disabled = busy;
    if (spinner) spinner.hidden = !busy;
    if (label) label.textContent = busy ? 'Submitting…' : 'Submit';
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function friendlyError(error) {
    if (error && error.name === 'AbortError') {
      return 'This is taking longer than expected. Please try again.';
    }
    if (error && error.status === 429) {
      return 'Too many requests have been sent. Please wait a moment and try again.';
    }
    if (error && error.status === 400) {
      return 'Please check the information entered and try again.';
    }
    return 'We could not connect to DS Store right now. Please try again shortly.';
  }

  function apiRequest(url, options) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT_MS);
    var requestOptions = Object.assign({}, options || {}, {
      signal: controller.signal,
      headers: Object.assign(
        { Accept: 'application/json' },
        options && options.headers ? options.headers : {}
      )
    });

    return fetch(url, requestOptions)
      .then(function (response) {
        return response.json().catch(function () {
          return null;
        }).then(function (body) {
          if (!response.ok || !body || body.success !== true) {
            var error = new Error('Request failed');
            error.status = response.status;
            throw error;
          }
          return body.data;
        });
      })
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function postJson(url, body) {
    return apiRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function showAskMessage(container, answerable, answer) {
    container.replaceChildren();
    container.classList.remove('product-faq__message--error');
    if (answerable) {
      var heading = document.createElement('strong');
      heading.textContent = 'AI Answer';
      var answerText = document.createElement('span');
      answerText.textContent = text(answer);
      var review = document.createElement('span');
      review.textContent = 'Your question has also been submitted for review.';
      container.append(heading, answerText, review);
    } else {
      var unavailable = document.createElement('strong');
      unavailable.textContent = "We couldn't confidently answer this question.";
      var submitted = document.createElement('span');
      submitted.textContent = 'Your question has been submitted to DS Store for review.';
      container.append(unavailable, submitted);
    }
    container.hidden = false;
  }

  function showError(container, message) {
    container.replaceChildren();
    container.classList.add('product-faq__message--error');
    container.textContent = message;
    container.hidden = false;
  }

  function payloadFromForm(form, primaryName) {
    var payload = {};
    payload[primaryName] = trimmedField(form, primaryName);
    var name = trimmedField(form, 'visitorName');
    var email = trimmedField(form, 'visitorEmail');
    if (name) payload.visitorName = name;
    if (email) payload.visitorEmail = email;
    return payload;
  }

  function communityField(labelText, name, type, maxLength, required) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product-faq__field';
    var label = document.createElement('label');
    var input = document.createElement(type === 'textarea' ? 'textarea' : 'input');
    var id = 'Community-' + name + '-' + Math.random().toString(36).slice(2);
    label.htmlFor = id;
    label.textContent = labelText;
    input.id = id;
    input.name = name;
    input.maxLength = maxLength;
    input.required = Boolean(required);
    if (type !== 'textarea') {
      input.type = type;
      if (type === 'email') input.autocomplete = 'email';
      if (name === 'visitorName') input.autocomplete = 'name';
    } else {
      input.rows = 2;
      input.minLength = 3;
    }
    wrapper.append(label, input);
    return wrapper;
  }

  function formatDate(value) {
    var date = new Date(value);
    return Number.isNaN(date.getTime())
      ? ''
      : new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(date);
  }

  function renderCommunityItem(item, apiBase) {
    var article = document.createElement('article');
    article.className = 'product-faq__community-item';
    var question = document.createElement('p');
    question.className = 'product-faq__community-question';
    question.textContent = text(item.question);
    var meta = document.createElement('p');
    meta.className = 'product-faq__community-meta';
    var answerCount = Number.isInteger(item.answerCount) ? item.answerCount : 0;
    meta.textContent =
      [formatDate(item.submittedAt), answerCount + (answerCount === 1 ? ' answer' : ' answers')]
        .filter(Boolean)
        .join(' · ');

    var form = document.createElement('form');
    form.className = 'product-faq__community-form';
    form.noValidate = true;
    form.append(
      communityField('Your Answer', 'answer', 'textarea', 1200, true),
      communityField('Your name (optional)', 'visitorName', 'text', 100, false),
      communityField('Email (optional)', 'visitorEmail', 'email', 254, false)
    );
    var actions = document.createElement('div');
    actions.className = 'product-faq__actions';
    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'product-faq__button';
    button.setAttribute('data-submit-button', '');
    var label = document.createElement('span');
    label.setAttribute('data-button-label', '');
    label.textContent = 'Submit';
    var spinner = document.createElement('span');
    spinner.className = 'product-faq__spinner';
    spinner.setAttribute('data-loading-spinner', '');
    spinner.setAttribute('aria-hidden', 'true');
    spinner.hidden = true;
    actions.append(button);
    button.append(label, spinner);
    form.append(actions);
    var message = document.createElement('div');
    message.className = 'product-faq__message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.hidden = true;

    var submitting = false;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (submitting) return;
      if (!form.reportValidity()) return;
      var payload = payloadFromForm(form, 'answer');
      if (payload.answer.length < 3) return;
      submitting = true;
      setBusy(form, true);
      message.hidden = true;
      postJson(
        apiBase + '/api/v1/public/questions/' + encodeURIComponent(text(item.questionId)) + '/answers',
        payload
      ).then(function () {
        message.classList.remove('product-faq__message--error');
        message.textContent = 'Thank you. Your answer has been submitted for moderation.';
        message.hidden = false;
        form.reset();
      }).catch(function (error) {
        showError(message, friendlyError(error));
      }).finally(function () {
        submitting = false;
        setBusy(form, false);
      });
    });

    article.append(question, meta, form, message);
    return article;
  }

  function initialiseAssistantBubble(section) {
    var bubble = section.querySelector('[data-assistant-bubble]');
    if (!bubble || section.dataset.assistantBubbleReady === 'true') return;

    var messages = [
      'Ask me anything about this product!',
      'I\u2019ll answer using verified DS Store information.',
      'Need help deciding? I\u2019m here to help.',
      'If I\u2019m not sure, I\u2019ll send your question to our team.'
    ];
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentIndex = 0;

    section.dataset.assistantBubbleReady = 'true';
    bubble.textContent = messages[0];
    if (reduceMotion || messages.length < 2) return;

    function showNextMessage() {
      bubble.classList.add('is-changing');
      section.productFaqBubbleTransition = window.setTimeout(function () {
        currentIndex = (currentIndex + 1) % messages.length;
        bubble.textContent = messages[currentIndex];
        bubble.classList.remove('is-changing');
        section.productFaqBubbleTransition = null;
      }, 180);
    }

    function startRotation() {
      if (section.productFaqBubbleTimer !== null || document.hidden) return;
      section.productFaqBubbleTimer = window.setInterval(showNextMessage, 4500);
    }

    function stopRotation() {
      if (section.productFaqBubbleTimer !== null) {
        window.clearInterval(section.productFaqBubbleTimer);
        section.productFaqBubbleTimer = null;
      }
    }

    section.productFaqBubbleTimer = null;
    section.productFaqBubbleTransition = null;
    section.productFaqBubbleVisibility = function () {
      if (document.hidden) stopRotation();
      else startRotation();
    };
    document.addEventListener(
      'visibilitychange',
      section.productFaqBubbleVisibility
    );
    startRotation();
  }

  function destroyAssistantBubble(section) {
    if (!section || section.dataset.assistantBubbleReady !== 'true') return;
    if (section.productFaqBubbleTimer !== null) {
      window.clearInterval(section.productFaqBubbleTimer);
    }
    if (section.productFaqBubbleTransition !== null) {
      window.clearTimeout(section.productFaqBubbleTransition);
    }
    if (section.productFaqBubbleVisibility) {
      document.removeEventListener(
        'visibilitychange',
        section.productFaqBubbleVisibility
      );
    }
    section.productFaqBubbleTimer = null;
    section.productFaqBubbleTransition = null;
    section.productFaqBubbleVisibility = null;
    delete section.dataset.assistantBubbleReady;
  }

  function initialise(section) {
    if (!section || section.dataset.questionUiReady === 'true') return;
    var handle = text(section.dataset.productHandle).trim();
    var apiBase = text(section.dataset.apiBase).trim().replace(/\/+$/, '');
    if (!handle || !/^https:\/\/[^/]+$/i.test(apiBase)) return;
    section.dataset.questionUiReady = 'true';
    initialiseAssistantBubble(section);

    var askForm = section.querySelector('[data-ask-form]');
    var askMessage = section.querySelector('[data-ask-message]');
    var communitySection = section.querySelector('[data-community-section]');
    var communityStatus = section.querySelector('[data-community-status]');
    var communityList = section.querySelector('[data-community-list]');
    var asking = false;

    function revealCommunity() {
      if (!communitySection) return;
      communitySection.hidden = false;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          communitySection.classList.add('is-visible');
        });
      } else {
        communitySection.classList.add('is-visible');
      }
    }

    if (askForm && askMessage) {
      askForm.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (asking) return;
        if (!askForm.reportValidity()) return;
        var payload = payloadFromForm(askForm, 'question');
        if (payload.question.length < 3) return;
        asking = true;
        setBusy(askForm, true);
        askMessage.hidden = true;
        postJson(
          apiBase + '/api/v1/public/products/' + encodeURIComponent(handle) + '/questions/ask',
          payload
        ).then(function (data) {
          showAskMessage(askMessage, data.answerable === true, data.answer);
          askForm.reset();
        }).catch(function (error) {
          showError(askMessage, friendlyError(error));
        }).finally(function () {
          asking = false;
          setBusy(askForm, false);
        });
      });
    }

    if (communityStatus && communityList) {
      window.setTimeout(function () {
        apiRequest(
          apiBase + '/api/v1/public/products/' + encodeURIComponent(handle) + '/questions/unanswered'
        ).then(function (data) {
          var questions = Array.isArray(data.questions) ? data.questions : [];
          communityList.replaceChildren();
          if (questions.length === 0) {
            communityStatus.hidden = false;
            communityStatus.textContent =
              'No community questions yet. Be the first to ask.';
            revealCommunity();
            return;
          }
          communityStatus.hidden = true;
          questions.forEach(function (item) {
            communityList.append(renderCommunityItem(item, apiBase));
          });
          revealCommunity();
        }).catch(function () {
          communityStatus.hidden = false;
          communityStatus.textContent =
            'Community questions are temporarily unavailable. Please try again later.';
          revealCommunity();
        });
      }, 0);
    }
  }

  function initialiseAll(root) {
    var scope = root || document;

    if (
      scope.nodeType === 1 &&
      typeof scope.matches === 'function' &&
      scope.matches('[data-product-faq]')
    ) {
      initialise(scope);
    }

    if (typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-product-faq]').forEach(initialise);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    }, { once: true });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (
      scope &&
      scope.nodeType === 1 &&
      typeof scope.matches === 'function' &&
      scope.matches('[data-product-faq]')
    ) {
      destroyAssistantBubble(scope);
    }
    if (scope && typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-product-faq]').forEach(
        destroyAssistantBubble
      );
    }
  });
})();
